import { STOREFRONT } from '@/lib/utils/translation';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useState } from 'react';
import SelectWithRemoteSearch from '../shared/SelectWithRemoteSearch';
import { env } from '@/constant/configs';
import { useRouter } from 'next/navigation';
import { SelectOptionType } from '@/lib/types/BaseType';

type CitiesCardProps = {
  lang: string;
  cardData: any;
  setCityData: (paylaod: any) => void;
};

const initialSelectOption: SelectOptionType = { id: -1, name: '' };

const CityNavigateCard = (props: CitiesCardProps) => {
  const { cardData, lang, setCityData } = props;
  const router = useRouter();
  const [selectedCityOption, setSelectedCityOption] =
    useState<SelectOptionType>(initialSelectOption);
  const t = useTranslations();

  const handleCitySelect = (option: SelectOptionType) => {
    setSelectedCityOption(option);
  };

  const navigateToCity = () => {
    if (selectedCityOption.id >= 0) {
      router.push(`/city/${selectedCityOption.slug}`);
    }
  };

  return (
    <div className="hero-city-card group relative inline-block h-[350px] w-full md:max-w-[600px] lg:h-[300px] lg:max-w-[450px] xl:max-w-[590px]">
      <div className="relative h-full w-full overflow-hidden rounded-[20px]">
        <Image
          src={
            cardData?.my_city?.image_path ??
            '/hero-section/hero-city-thumb.jpeg'
          }
          alt={
            cardData?.my_city?.h3?.[lang] ??
            t(STOREFRONT.HOME + '.hero_section.my_city')
          }
          className="object-cover transition-all duration-500 ease-linear group-hover:scale-125"
          fill
        />
      </div>
      <div className="absolute inset-0 rounded-[20px] bg-black opacity-0 group-hover:opacity-30" />
      <div className="absolute bottom-[25px] left-[20px] right-[30px] z-[30]">
        <h3 className="mb-3 text-h5 font-bold text-white">
          {cardData?.my_city?.h3?.[lang] ??
            t(STOREFRONT.HOME + '.hero_section.my_city')}
        </h3>
        <div className="flex max-w-[70%] flex-col items-start justify-center space-y-5 xl:flex-row xl:items-center xl:justify-start xl:space-x-2 xl:space-y-0">
          <SelectWithRemoteSearch
            apiEndpoint={env.api_url + '/v1/customer/cities'}
            selectedOption={selectedCityOption}
            onSelect={handleCitySelect}
            paramKey="name"
            placeholder={
              cardData?.my_city?.search_placeholder?.[lang] ??
              t('common.search_city')
            }
            initalParams={{
              is_favourite: 0,
            }}
            extraParams={{
              order_by: 'order_index',
              order_dir: 'asc',
              per_page: 20,
            }}
            roundClass="rounded-full"
            inputClass="xl:max-w-[180px]"
            setInitialRemoteData={(data) => setCityData(data)}
          />
          <button
            type="button"
            onClick={() => navigateToCity()}
            className="rounded-full border-2 border-primary-700 bg-primary-700 px-[28px] py-1 text-base font-[600] text-white transition-colors hover:bg-white hover:text-primary-700 disabled:opacity-90 disabled:hover:bg-primary-700 disabled:hover:text-white"
          >
            {cardData?.my_city?.search_button_label?.[lang] ?? t('search')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CityNavigateCard;
